import { CustomSnippet, CreateCustomSnippetPayload, UpdateCustomSnippetPayload } from '@/types/api';
import { getApiBaseUrl, handleResponse } from './client';

// Custom Snippet API calls
export async function getCustomSnippets(): Promise<CustomSnippet[]> {
  const response = await fetch(`${getApiBaseUrl()}/custom-snippets`);
  return handleResponse<CustomSnippet[]>(response);
}

export async function createCustomSnippet(payload: CreateCustomSnippetPayload): Promise<CustomSnippet> {
  const response = await fetch(`${getApiBaseUrl()}/custom-snippets`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return handleResponse<CustomSnippet>(response);
}

export async function updateCustomSnippet(id: string, payload: UpdateCustomSnippetPayload): Promise<CustomSnippet> {
  const response = await fetch(`${getApiBaseUrl()}/custom-snippets/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return handleResponse<CustomSnippet>(response);
}

export async function deleteCustomSnippet(id: string): Promise<void> {
  const response = await fetch(`${getApiBaseUrl()}/custom-snippets/${id}`, {
    method: 'DELETE',
  });
  await handleResponse<void>(response);
}

export async function duplicateCustomSnippet(id: string): Promise<CustomSnippet> {
  const response = await fetch(`${getApiBaseUrl()}/custom-snippets/${id}/duplicate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  });
  return handleResponse<CustomSnippet>(response);
}